import { SortBoolDescendingVariantIcon } from './SortBoolDescendingVariantIcon';

/**
 * author: frankgrinaert
 * id 549371B9-36F9-45E7-918A-72EEB98F9572
 * name sort-bool-descending-variant
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-bool-descending-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const SortCheckboxDescendingIcon = SortBoolDescendingVariantIcon;
export default SortCheckboxDescendingIcon